import { render, staticRenderFns } from "./PaginationButton.vue?vue&type=template&id=151d0b6e&scoped=true"
import script from "./PaginationButton.vue?vue&type=script&lang=ts"
export * from "./PaginationButton.vue?vue&type=script&lang=ts"
import style0 from "./PaginationButton.vue?vue&type=style&index=0&id=151d0b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d0b6e",
  null
  
)

export default component.exports